export default {
  suspiciousTransactionDetails: {
    date: 'Date',
    merchant: 'Merchant',
    amount: 'Amount',
    card: 'Card',
    noteLabel:
      'Please be careful in selecting your response, once confirmed your response cannot be changed.',
  },
  suspiciousTransactionResult: {
    cardReplaced: {
      title: 'Your new card is on the way',
      description:
        'When it arrives in 1-2 weeks make sure to update your recurring and automatic payments.',
    },
    done: 'Done',
  },
};
